import { render, staticRenderFns } from "./PermissionUnits.vue?vue&type=template&id=9aadbe34"
import script from "./PermissionUnits.vue?vue&type=script&lang=js"
export * from "./PermissionUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports